import * as types from './acounting_action_type'
const initialState = {
    companystatelist: [],
    hisabReportDropData:[],
    hisabReportSummaryData:[],
    hisabReportDetailedData:[]
}

const acountingReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.COMPANY_STATE_LIST:
            return { ...state, companystatelist: action.data }
        case types.HISAB_REPORT_DROP_DATA:
            return { ...state, hisabReportDropData: action.data }
        case types.HISAB_REPORT_SUMMARY_DATA:
            return { ...state, hisabReportSummaryData: action.data }
        case types.HISAB_REPORT_DETAILED_DATA:
            return { ...state, hisabReportDetailedData: action.data }
        default:
            return state

    }
}
export default acountingReducer;
